module.exports = __webpack_public_path__ + "img/IMG_8990.7a721419.jpg";